
import Vue from "vue";
import AppCashierCheckModal from "@/components/cashier/CashierCheckModal.vue";

export default Vue.extend({
	methods: {
		close(){
			this.$router.push("/");
		}
	},
	components: {
		AppCashierCheckModal
	},
	i18nEx: {
		componentPrefix: "components.sales.CashierRefund"
	},
});
